var TELEMETRY_PRODUCT_TABLE_NAME = 'lcm_ui';
export var initTelemetry = function (history, collectorId, instanceId, isProduction, ceipEnabled) {
    if (ceipEnabled && process.env.REACT_APP_ENABLE_TELEMETRY === 'true') {
        // @ts-ignore
        import('./vts.js').then(function () {
            // @ts-ignore
            var _paq = window._paq || [];
            var initFnName = isProduction ? 'initProduction' : 'initStaging';
            _paq.push([
                initFnName,
                ceipEnabled,
                collectorId,
                instanceId,
                TELEMETRY_PRODUCT_TABLE_NAME
            ]);
            _paq.push(['trackPageView']);
            _paq.push(['enableLinkTracking']);
            history.listen(function (location) {
                _paq.push(['setCustomUrl', location.pathname]);
                _paq.push(['trackPageView']);
            });
        });
    }
};
